import { EOfferType } from '../repositories/favorites/v1/add-offers-in-folders';
export var mapOfferType = function mapOfferType(offerType) {
  var offerTypes = {
    commercial: EOfferType.Commercial,
    flat: EOfferType.Flat,
    newobject: EOfferType.Newobject,
    suburban: EOfferType.Suburban
  };
  return offerTypes[offerType];
};